import { ValidationSummary } from "devextreme-react/validation-summary";
import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useContext, useRef, useState } from "react";
import { Field } from "../../../../layouts";
import { AR, FileTypes, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import Validator, { RequiredRule } from "devextreme-react/validator";
import { showErrorMessage } from "../../../../utils/messages";
import { LoadPopupPanel } from "../../../../components";
import { useAcceptChangeOrder } from "../api/accept-change-order";
import { TextBox } from "devextreme-react/text-box";
import { NumberBox } from "devextreme-react";
import { useGetCompany } from "../../../../api/company";
import { useAuth } from "../../../../contexts/auth";
import RetailOrderFiles from "./RetailOrderFiles";
import { useNavigate } from "react-router-dom";

export default function AcceptChangeOrderButton() {

	const { user } = useAuth();
	const userCompany = useGetCompany(user?.companyId);
	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const [isSuccessPopupVisible, setSuccessPopupVisibility] = useState(false);
	const [newRetailOrderID, setNewRetailOrderID] = useState<number>();

	const poNumberRef = useRef<TextBox>(null);
	const poAmountRef = useRef<NumberBox>(null);

	const navigate = useNavigate();

	const acceptChangeOrder = useAcceptChangeOrder(
		(newRetailOrderID) => {
			setPopupVisibility(false);
			refetchOrder();
			setNewRetailOrderID(newRetailOrderID);
			setSuccessPopupVisibility(true);
		},
		(error) => showErrorMessage(error)
	)

	const isCabinetOrder = order.details.roTypeID === ROType.CabinetMeasureOrder || order.details.roTypeID === ROType.CabinetInstallOrder;

	return (
		<>
			<Button elementAttr={{ 'data-testid': 'btn-accept-change-order' }}
				text="Accept Change Order"
				icon="Inscyth-Confirm"
				visible={(order.details.activeARs.includes(AR.CorporateToAcceptChangeOrder) && userCompany.data?.isParent) /*||
					(order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) && isCabinetOrder)*/}
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			<Popup
				title="Accept Change Order"
				width={700}
				height={500}
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: function () {
							setPopupVisibility(false);
						}
					}}
					widget="dxButton"
					location="after"
				/>
				<ValidationSummary validationGroup="acceptChangeOrderGroup"></ValidationSummary>
				{
					order.details.activeARs.includes(AR.CorporateToAcceptChangeOrder) &&
					<Field label="PO Number">
						<TextBox inputAttr={{ 'data-testid': 'po-number' }}
							className='required'
							ref={poNumberRef}
						>
							<Validator validationGroup='acceptChangeOrderGroup'>
								<RequiredRule message={'PO Number is required'}></RequiredRule>
							</Validator>
						</TextBox>
					</Field>
				}
				{
					order.details.activeARs.includes(AR.CorporateToAcceptChangeOrder) &&
					<Field label="PO Amount">
						<NumberBox inputAttr={{ 'data-testid': 'po-amount' }}
							className='required'
							ref={poAmountRef}
							format={{ type: 'currency', precision: 2 }}
							showSpinButtons={true}
						>
							<Validator validationGroup='acceptChangeOrderGroup'>
								<RequiredRule message={'PO Amount is required'}></RequiredRule>
							</Validator>
						</NumberBox>
					</Field>
				}
				<RetailOrderFiles
					fileTypes={[FileTypes.UploadPO]}
					defaultFileType={FileTypes.UploadPO}
					buttonCaption="Upload PO"
					closeOnUpload={true}
				/>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Submit',
						validationGroup: 'acceptChangeOrderGroup',
						onClick: (e: any) => {
							if (e.validationGroup.validate().isValid) {

								if (!order.details.files.find(x => x.fileTypeID === FileTypes.UploadPO)) {
									showErrorMessage("Upload PO file is required");
								}
								else {
									acceptChangeOrder.mutate({
										retailOrderID: order.details.retailOrderID,
										poNumber: poNumberRef.current?.instance.option("value")!,
										poAmount: poAmountRef.current?.instance.option("value")!
									});
								}
							}
						}
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Cancel',
						onClick: () => setPopupVisibility(false)
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<LoadPopupPanel visible={acceptChangeOrder.isLoading}></LoadPopupPanel>
			</Popup>
			<Popup
				showTitle={false}
				width={400}
				height={180}
				visible={isSuccessPopupVisible}
				hideOnOutsideClick={false}
				onHiding={() => setSuccessPopupVisibility(false)}
			>
				<p style={{ textAlign: 'center' }}>
					Retail Order has been created successfully.
				</p>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Go to New Order',
						onClick: () => {
							navigate('/dealer/retail-order/' + newRetailOrderID);
							setSuccessPopupVisibility(false);
						}
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="before"
				>
				</ToolbarItem>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Close',
						onClick: () => setSuccessPopupVisibility(false)
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<LoadPopupPanel visible={acceptChangeOrder.isLoading}></LoadPopupPanel>
			</Popup>
		</>
	)
}
